/*eslint-disable*/
import React, { useState } from "react";
import {
  Card,
  CardBody,
  Label,
  FormGroup,
  Row,
  Input,
  Container,
  CardHeader,
  CardFooter,
  Button,
  Form, FormFeedback
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import axios from 'axios';
import SimpleHeader from "components/Headers/SimpleHeader.js";

export default function CreateAcquirer(props) {
  const token = localStorage.getItem("token");
  const id = props.match.params.id;
  const [unitKerja, setUnitKerja] = useState("");
  const [unitKerjaError, setUnitKerjaError] = useState(null);
  const [unitKerjaDuplicate, setUnitKerjaDuplicate] = useState(null);
  const [isLoading, setLoading] = useState(false);
  let history = useHistory();

  const validateForm = () => {
    let error = false;
    if (unitKerja === "") {
      setUnitKerjaError("invalid");
      error = true;
    }
    return error;
  };

  function CreateData() {
    setLoading(true);
    let data = {
      merchant_pk: parseInt(id),
      workUnitName: unitKerja
    }
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/workunit/create`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
      .then(function (response) {
        if (response.data.error) {
          showErrors(response.data.error);
          return;
        }
        history.push("/admin/customers/daftar-project");
      })
      .then(json => {
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  const showErrors = (error) => {
    let errors = false;
    if (error.error_message) {
      setUnitKerjaError("invalid");
      setUnitKerjaDuplicate(error.error_message);
      errors = true;
    }
    return errors;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) {
      CreateData();
    }
  }

  return (
    <>
      <SimpleHeader name="Daftar Unit Kerja" parentName="Admin" />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardBody>
                <Form onSubmit={handleSubmit}>
                  <CardHeader>
                    <h3>Daftar Unit Kerja</h3>
                  </CardHeader>
                  <CardBody>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="exampleFormControlInput1"
                      >
                        Nama Unit Kerja
                      </Label>
                      <Input
                        id="example-date-input"
                        type="text"
                        placeholder="Masukan Nama Unit Kerja"
                        value={unitKerja}
                        invalid={unitKerjaError === "invalid"}
                        onChange={(e) => {
                          setUnitKerja(e.target.value);
                          if (e.target.value !== "") {
                            setUnitKerjaError("");
                          }
                        }}
                      />
                      <FormFeedback>
                        {
                          unitKerja === "" ? "Nama Unit Kerja tidak boleh kosong" : unitKerjaDuplicate
                        }
                      </FormFeedback>
                    </FormGroup>
                  </CardBody>
                  <CardFooter>
                    {!isLoading && (<Button color="primary" type="submit">
                      Simpan
                    </Button>)}
                    {isLoading && (<Button color="primary" disabled>
                      <i className="fas fa-spinner fa-spin"></i>{""}
                      Loading...
                    </Button>)}
                    <Link class="btn btn-info" to="/admin/customers/daftar-project">
                      Kembali
                                        </Link>
                  </CardFooter>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}
